import { PROVINCES, STEPS_OPTIONS } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  loaderText: null,
  streetType: null,
  documentType: null,
  maritalStatus: null,
  financialIncomes: null,
  profession: null,
  sex: null,
  signType: null,
  provinces: PROVINCES,
  stepsOptions: STEPS_OPTIONS,
  headerLogos: {
    logoFrontLeft: null,
    logoFrontRight: null
  },
  footerLogos: [],
  theme: 'ald-bbva',
  footerPubli: null,
  urlFooterLastStep: null,
  disclaimer: null,
  townsCache: {},
  townsProvinceCodeCache: [],
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
